import noop from 'lodash/noop';
import { defaultLocale } from '@jira/platform__supported-locales/src/supported-locales.tsx';
import { SET, type SetAction } from './actions.tsx';
import type { Context } from './types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type ContextState = Context;

type Action = SetAction;

export const initialState: ContextState = Object.freeze({
	isAdmin: false,
	locale: defaultLocale,
	onQueryChanged: noop,
});

const context = (state: ContextState = initialState, action: Action): ContextState => {
	switch (action.type) {
		case SET: {
			return Object.freeze(action.payload);
		}
		default:
			return state;
	}
};

export default context;
